// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__e-l5q","selectLabel":"Settings_selectLabel__vsqbZ","switchField":"Settings_switchField__3RxVs","switchLabel":"Settings_switchLabel__1Myoj"};